/**
 * Message templates that use the current firm's name & contact.
 * Called by all WhatsApp buttons across the app.
 */
export function firmSig(firm) {
  if (!firm) return "";
  const name = firm.firm_name || "";
  const phone = firm.contact || "";
  return `\n\nWith regards,\n${name}${phone ? ` · ${phone}` : ""}`;
}

export function partyBalanceMessage(party, net, firm) {
  const amt = Math.abs(Number(net) || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const body = net > 0
    ? `Dear ${party.name},\n\nThis is a gentle reminder that ₹${amt} is pending from your side against outstanding invoices with us. Kindly arrange the payment at your earliest convenience.`
    : net < 0
      ? `Dear ${party.name},\n\nWe have ₹${amt} payable to you. We will process the payment shortly.`
      : `Dear ${party.name},\n\nThis is a friendly reminder from our end. Your ledger is currently settled.`;
  return body + firmSig(firm);
}

export function invoiceMessage(txn, firm, publicUrl) {
  const num = txn?.number || "";
  const total = Number(txn?.total || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const bal = Number(txn?.balance || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  let body = `Dear ${txn?.party_name || "Customer"},\n\nThank you for your business. Please find the invoice details below:\n`;
  body += `\nInvoice No: ${num}`;
  body += `\nDate: ${new Date(txn?.date || Date.now()).toLocaleDateString()}`;
  body += `\nTotal: ₹${total}`;
  if (Number(txn?.balance || 0) > 0) body += `\nBalance Due: ₹${bal}`;
  if (publicUrl) body += `\n\nInvoice link: ${publicUrl}`;
  return body + firmSig(firm);
}

export function genericMessage(intro, firm) {
  return `${intro}${firmSig(firm)}`;
}
